<template>
  <div class="footer-block">
    <div class="separator" />
    <footer>
      <div><p>© Menlor.ru {{ new Date().getFullYear() }}</p></div>
      <div class="icons-social">
        <p>
          <a
            href="#"
            @click.prevent="copyEmail"
          >{{ copied ? 'Почта скопирована в буфер' : 'Написать мне' }}</a>
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "FooterBottom",
  data(){
    return {
      copied: false,
      timeoutReset: null,
    }
  },
  beforeUnmount(){
    clearTimeout(this.timeoutReset)
  },
  methods: {
    async copyEmail(){
      clearTimeout(this.timeoutReset);
      try {
        await navigator.clipboard.writeText('info@menlor.ru');
      } catch (e) {
        console.error(e);
      }
      this.copied = true;
      this.timeoutReset = setTimeout(() => { this.copied = false }, 4000)
    },
  }
}
</script>

<style scoped>
.footer-block{
  margin-top: auto;
}
footer{
  display: grid;
  grid-template-columns: 240px  240px;
  justify-content: space-between;
  list-style: none;
  gap: 40px;
  margin:0;
  padding: 0 10px;
  margin-bottom: 20px;
}
footer p{
  margin: 0;
}
footer div{
  padding: 0 10px;
  width: max-content;
  align-self: end;
}

footer div:last-child{
  justify-self: end;
}
.icons-social a{
 border-bottom: 0;
}
p {
  text-align: left;
}

@media screen and (max-width:800px){
  footer{
    grid-template-columns: 1fr;
  }
  footer div:last-child {
    justify-self: start;
  }
}
</style>